import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import formatDate from '../utils/formatDate';
import parseDate from '../utils/parseDate';
/**
 * A date typed as jj.mm.aaaa - the format formatDate() shows everywhere
 * else - in place of a native <input type="date">, whose format is the
 * browser's own language's, not the page's: an English-speaking browser
 * showed mm/dd/yyyy (2026-10-15), whatever lang="fr" says.
 *
 * The calendar button still opens the browser's own date picker (a
 * hidden native date input's showPicker()) - not offered where there's
 * none (older Safari): typing alone works there.
 *
 * A copy of champis-exhibitions' DateField (and of its parseDate() and
 * formatDate()): the two extensions don't depend on each other. Same
 * styles, .ChampisDateField in champis-theme. A change here goes there too.
 */
export default class DateField extends Component {
  text = '';
  // Flagged as invalid only once left, not while being (re)typed.
  touched = false;
  picker = null;
  oninit(vnode) {
    super.oninit(vnode);
    this.text = formatDate(this.attrs.value) || '';
  }
  view() {
    const iso = parseDate(this.text);
    const invalid = this.touched && this.text.trim() !== '' && iso === null;
    return m("span", {
      className: 'ChampisDateField' + (invalid ? ' ChampisDateField--invalid' : '')
    }, m("span", {
      className: "ChampisDateField-inputs"
    }, m("input", {
      className: "FormControl",
      type: "text",
      placeholder: app.translator.trans('champis-events.forum.date_field.placeholder', {}, true),
      value: this.text,
      "aria-invalid": invalid ? 'true' : undefined,
      oninput: e => {
        this.text = e.target.value;
        this.touched = false;
        this.attrs.onchange(this.text.trim() === '' ? '' : parseDate(this.text));
      },
      onblur: () => {
        this.touched = true;
        // "1.2.26" -> "01.02.2026": what will be saved.
        if (iso) this.text = formatDate(iso) || this.text;
      }
    }), 'showPicker' in HTMLInputElement.prototype && m("button", {
      type: "button",
      className: "Button Button--icon",
      "aria-label": app.translator.trans('champis-events.forum.date_field.calendar_button', {}, true),
      onclick: () => {
        try {
          this.picker?.showPicker();
        } catch {
          // Not allowed here (no user gesture, hidden): typing still works.
        }
      }
    }, m(Icon, {
      name: "far fa-calendar-alt"
    })), m("input", {
      className: "ChampisDateField-picker",
      type: "date",
      tabindex: "-1",
      "aria-hidden": "true",
      value: iso ?? '',
      oncreate: vnode => {
        this.picker = vnode.dom;
      },
      onchange: e => {
        const picked = e.target.value;
        this.text = formatDate(picked) || '';
        this.touched = true;
        this.attrs.onchange(picked);
      }
    })), invalid && m("span", {
      className: "ChampisDateField-error"
    }, app.translator.trans('champis-events.forum.date_field.invalid')));
  }
}
flarum.reg.add('champis-events', 'forum/components/DateField', DateField);